import { Gamepad2 } from 'lucide-react'
import { resolvePlayerAssetUrl } from '@/lib/player-api'
import { cn } from '@/lib/utils'
import type { CasinoProvider } from '@/types/casino'

interface ProviderCardProps {
	provider: CasinoProvider
	className?: string
}

export function ProviderLobbyCard({ provider, className }: ProviderCardProps) {
	return (
		<div
			className={cn(
				'group relative h-[140px] shrink-0 transition-[border-color,box-shadow,width] duration-300 ease-in-out',
				'duration-500 animate-in fade-in zoom-in-90 slide-in-from-bottom-[150%] fill-mode-both [animation-timing-function:cubic-bezier(0.22,1.18,0.36,1)]',
				className,
			)}
		>
			<div className='absolute inset-0 flex flex-col overflow-hidden rounded-2xl bg-card [clip-path:polygon(0%_0%,100%_0%,100%_100%,72%_100%,62%_92%,38%_92%,28%_100%,0%_100%)]'>
				<div className='flex min-h-0 flex-1 items-center justify-center px-4 py-5'>
					{provider.logo_url ? (
						<img src={resolvePlayerAssetUrl(provider.logo_url)} alt={provider.provider_name} className='max-h-10 max-w-[140px] object-contain' />
					) : (
						<span className='line-clamp-2 text-center text-sm font-semibold tracking-[-0.21px] text-foreground'>{provider.provider_name}</span>
					)}
				</div>

				<div className='mx-2 mb-4 flex items-center justify-center gap-2 rounded-xl bg-secondary px-3 py-2.5'>
					<Gamepad2 className='h-4 w-4 shrink-0 text-muted-foreground' />
					<span className='text-sm font-medium tracking-[-0.21px] text-muted-foreground'>Game: {provider.casinos_count}</span>
				</div>
			</div>

			<div
				aria-hidden
				className='pointer-events-none absolute -inset-[5px] rounded-2xl bg-[linear-gradient(180deg,hsl(var(--primary))_0%,hsl(var(--primary)/0)_80%)] p-[1.5px] opacity-0 shadow-[0_0_2px_0_hsl(var(--primary)/0.20)] transition-opacity duration-300 group-hover:opacity-100'
				style={{
					WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
					WebkitMaskComposite: 'xor',
					maskComposite: 'exclude',
				}}
			/>

			<span
				className='pointer-events-none absolute bottom-0 left-1/2 z-10 h-1 w-8 -translate-x-1/2 rounded-full bg-border duration-200 ease-in-out group-hover:w-10 group-hover:bg-primary group-hover:shadow-[0_0_6px_2px_hsl(var(--primary)/0.55)]'
				aria-hidden
			/>
		</div>
	)
}

export function ProviderContentCard({ provider, className }: ProviderCardProps) {
	return (
		<div
			className={cn(
				'group relative h-[88px] shrink-0 transition-[border-color,box-shadow,width] duration-300 ease-in-out',
				'duration-500 animate-in fade-in zoom-in-90 slide-in-from-bottom-[150%] fill-mode-both [animation-timing-function:cubic-bezier(0.22,1.18,0.36,1)]',
				className,
			)}
		>
			<div className='absolute inset-0 flex items-center justify-center overflow-hidden rounded-2xl bg-card px-4 [clip-path:polygon(0%_0%,100%_0%,100%_100%,72%_100%,62%_92%,38%_92%,28%_100%,0%_100%)]'>
				{provider.logo_url ? (
					<img src={resolvePlayerAssetUrl(provider.logo_url)} alt={provider.provider_name} className='max-h-8 max-w-[150px] object-contain' />
				) : (
					<span className='line-clamp-1 text-center text-sm font-semibold tracking-[-0.21px] text-muted-foreground'>{provider.provider_name}</span>
				)}
			</div>

			<div
				aria-hidden
				className='pointer-events-none absolute -inset-[5px] rounded-2xl bg-[linear-gradient(180deg,hsl(var(--primary))_0%,hsl(var(--primary)/0)_80%)] p-[1.5px] opacity-0 shadow-[0_0_2px_0_hsl(var(--primary)/0.20)] transition-opacity duration-300 group-hover:opacity-100'
				style={{
					WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
					WebkitMaskComposite: 'xor',
					maskComposite: 'exclude',
				}}
			/>

			<span
				className='pointer-events-none absolute bottom-0 left-1/2 z-10 h-1 w-8 -translate-x-1/2 rounded-full bg-border duration-200 ease-in-out group-hover:w-10 group-hover:bg-primary group-hover:shadow-[0_0_6px_2px_hsl(var(--primary)/0.55)]'
				aria-hidden
			/>
		</div>
	)
}
